/**
 * Segnaposto ammessi nei modelli email, con la spiegazione che il portale
 * mostra a chi scrive il modello. Vivono qui perche' li usano sia il portale
 * (anteprima e controllo) sia il worker (composizione dell'email).
 */
export const SEGNAPOSTO: Record<string, string> = {
  nome: 'Nome del destinatario',
  azienda: 'Ragione sociale dell azienda',
  impianto: 'Codice ditta dell impianto',
  anno: 'Anno d imposta',
  periodo: 'Periodo della dichiarazione',
  scadenza: 'Data della scadenza',
  adempimento: 'Nome dell adempimento in scadenza',
  link: 'Collegamento alla pagina del cliente',
  partner: 'Ragione sociale del partner che invia',
}

const GRAFFE = /\{\{\s*([a-z_]+)\s*\}\}/g

/** Il corpo di un'email e' HTML: un valore non protetto lo romperebbe. */
const proteggi = (s: string): string =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

export function compila(testo: string, valori: Readonly<Record<string, string>>): string {
  return testo.replace(GRAFFE, (_, chiave: string) => proteggi(valori[chiave] ?? ''))
}

/** Segnaposto usati nel testo ma non previsti: quasi sempre un refuso. */
export function segnapostoMancanti(testo: string): string[] {
  return [...testo.matchAll(GRAFFE)].map((m) => m[1]!).filter((c) => !(c in SEGNAPOSTO))
}
